const ENV = {
    BASE_URL: process.env.REACT_APP_BASE_URL,
    API_KEY: process.env.REACT_APP_API_KEY,
    COMPANY_ID: process.env.REACT_APP_COMPANY_ID,
    TIMEOFF_BASE_URL: process.env.REACT_APP_TIMEOFF_BASE_URL
}

export default ENV;
